import { useEffect, useRef, useState } from 'react'
import { useUserStore } from '../../store/userStore';
import { Link, useParams } from 'react-router-dom';
import { getConfigApi } from '../../api/config';
import SavePDFButton from '../../components/common/pdf/SavePDFButton';
import SchoolRecordVer2ReadForm from '../../components/schoolRecord/form/SchoolRecordVer2ReadForm';

const SchoolRecordReadPage = () => {
    /* zustand */
    const { userInfo } = useUserStore(state => state)

    const { schoolRecordId } = useParams()

    const pdfRef = useRef();

    const [isShow, setIsShow] = useState(false)

    useEffect(() => {
        getIsShow()
    }, [])

    const getIsShow = async () => {
        try {
            const response = await getConfigApi('school_record')
            if (response.data.code === 200) {
                const isShow = response.data.resData.is_show === '1' ? true : false
                setIsShow(isShow)
            }
            else {
                throw new Error("get is show failed");
            }

        } catch (error) {
            console.log(error);
            setIsShow(false)
        }
    }

    return (
        <>
            <div className='mb-3'>
                <div className='d-flex'>
                    <h3 className='h3'>생활기록부 조회</h3>
                    <div className='ms-3'>
                        <SavePDFButton pdfRef={pdfRef} fileName={`${userInfo?.name} 학생 생활기록부`} btnColor={'secondary'} />
                    </div>
                </div>
            </div>

            {
                !isShow
                    ? <IsShowFalse />
                    : <SchoolRecordInfo schoolRecordId={schoolRecordId} pdfRef={pdfRef} />
            }
        </>
    )
}

const SchoolRecordInfo = ({ schoolRecordId, pdfRef }) => {

    return (
        <div className='py-3'>
            <div className='py-3'>
                <SchoolRecordVer2ReadForm schoolRecordId={schoolRecordId} pdfRef={pdfRef} isAdmin={false} />
            </div>

            <div className='py-3 text-center'>
                <Link to={'/school-record'} className='btn btn-secondary'>목록으로</Link>
            </div>
        </div>
    )
}

const IsShowFalse = () => {
    return (
        <div>생활기록부 열람 기간이 아닙니다.</div>
    )
}

export default SchoolRecordReadPage